/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProductsJsmChatopsSlackAppSelectorEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{}
>;

export const productsJsmChatopsSlackAppSelectorEntryPoint: EntryPoint<
	ProductsJsmChatopsSlackAppSelectorEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<ProductsJsmChatopsSlackAppSelectorEntryPointComponent>(
		/* webpackChunkName: "async-products-jsm-chatops-slack-app-selector", jiraSpaEntry: "async-products-jsm-chatops-slack-app-selector" */ './ProductsJsmChatopsSlackAppSelectorType.tsx',
	),
	getPreloadProps: () => ({
		queries: {},
	}),
});
